var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgComment(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 47,
    height: 39,
    viewBox: "0 0 47 39",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.4376 0.733887L12.3036 28.0399L10.3356 18.8149C13.2056 18.8149 15.5836 19.7169 17.4696 21.5209C19.3556 23.3249 20.2986 25.7439 20.2986 28.7779C20.2986 31.8119 19.3556 34.2719 17.4696 36.1579C15.5836 37.9619 13.2466 38.8639 10.4586 38.8639C7.50662 38.8639 5.08762 37.9209 3.20162 36.0349C1.31562 34.1489 0.37262 31.7299 0.37262 28.7779C0.37262 27.7939 0.41362 26.8919 0.495619 26.0719C0.659619 25.1699 0.946619 24.1039 1.35662 22.8739C1.76662 21.6439 2.34062 20.0859 3.07862 18.1999L9.59762 0.733887H19.4376ZM45.5136 0.733887L38.3796 28.0399L36.4116 18.8149C39.2816 18.8149 41.6596 19.7169 43.5456 21.5209C45.4316 23.3249 46.3746 25.7439 46.3746 28.7779C46.3746 31.8119 45.4316 34.2719 43.5456 36.1579C41.6596 37.9619 39.3226 38.8639 36.5346 38.8639C33.5826 38.8639 31.1636 37.9209 29.2776 36.0349C27.3916 34.1489 26.4486 31.7299 26.4486 28.7779C26.4486 27.7939 26.4896 26.8919 26.5716 26.0719C26.7356 25.1699 27.0226 24.1039 27.4326 22.8739C27.8426 21.6439 28.4166 20.0859 29.1546 18.1999L35.6736 0.733887H45.5136Z",
    fill: "#C32A7C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgComment);
export default __webpack_public_path__ + "static/media/comment.f0c49d404a317b8561dc9e6adb5ee9c9.svg";
export { ForwardRef as ReactComponent };